<template>
  <!-- eslint-disable -->
  <div v-if="visible" class="modal-backdrop-custom" @click.self="close">
    <div class="modal-custom">
      <div class="modal-header">
        <h5>Comenta la orden {{ ordenId }}</h5>
        <button @click="close" class="close">&times;</button>
      </div>

      <div class="modal-body">
        <textarea
          v-model="comentario"
          class="form-control"
          placeholder="Escribe tu comentario aquí..."
          maxlength="500"
        ></textarea>
        <small>{{ comentario.length }}/500</small>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" @click="close">Cancelar</button>
        <button class="btn btn-primary" @click="comentar">Enviar</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ModalComentario',
  props: [],
  data() {
    return {
      visible: false,
      comentario: '',
      ordenId: null
    };
  },
  methods: {
    open(ordenId) {
      this.ordenId = ordenId;
      this.comentario = '';
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    // comentar() {
    //   if (this.comentario.length > 500) return;
    //   axios.post('/api/admin/hacer_comentario', {
    //     orden_id: 27004,
    //     texto: this.comentario
    //   })
    //     .then(() => {
    //       this.close();
    //       this.$emit('comentado');
    //     })
    //     .catch(e => {
    //       console.error(e);
    //     });
    // }
    comentar() {
      if (this.comentario.length <= 500) {
        axios.post(window.hostname + '/api/admin/hacer_comentario',
          { orden_id: this.ordenId, texto: this.comentario })
          .then(response => {
            this.comentando = false;
            this.comentario = ''
            this.close();
      this.$notify({
        group: 'foo',
        title: 'Comentario enviado',
        text: 'Tu comentario fue guardado correctamente.',
        type: 'success'
      });
          })

          .catch(e => {
            console.log(e.response)
            if (e.response.data.message)
              this.$notify({
                group: 'foo',
                title: '¡Error!',
                text: e.response.data.message,
                type: 'error'
              });
            this.resultado = e.response.data.message
          })
      }

    },
  }
};
</script>

<style scoped>
.modal-backdrop-custom {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}
.modal-custom {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 90%;
  max-width: 500px;
}
.close {
  background: none;
  border: none;
  font-size: 24px;
  float: right;
  cursor: pointer;
}
</style>